<template>
  <div class="iqos-grid">
    <div class="iqos-column">
      <PromocodeGroupCard 
        v-for="group in uiColumns.first"
        :group="group"
        @deleted="fetchData"
        :key="group._id"/>
    </div>
    <div class="iqos-column">
      <PromocodeGroupCard 
        v-for="group in uiColumns.second"
        :group="group"
        @deleted="fetchData"
        :key="group._id"/>
    </div>

    <AddPromocodeModal 
        @created="add_modal = false; fetchData();"
        @close="add_modal = false"
        v-if="add_modal"/>
  </div>
</template>

<script>
import PromocodeGroupCard from "@/components/marketing/PromocodeGroupCard.vue"
import AddPromocodeModal from "@/components/marketing/AddPromocodeModal.vue"
import Popup from "@/components/PopUp.vue"

import PromocodesAPI from "@/api/promocodes"

export default {
  data() {
    return {
      promocode_groups: [],

      add_modal: false
    }
  },
  methods: {
    fetchData() {
      PromocodesAPI.getGroups(
        this.cafe._id
      ).then(data => {
        this.promocode_groups = data.promocode_groups;
      }).catch(err => {
        this.$store.dispatch('showError', 'promocodes_error');
      });
    },
    showAddPromocodeUI() {
      this.add_modal = true;
    }
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    uiColumns() {
      return {
        first: this.promocode_groups.filter((v,i) => i % 2 == 0),
        second: this.promocode_groups.filter((v,i) => i % 2 != 0)
      }
    }
  },
  components: {
    PromocodeGroupCard,
    AddPromocodeModal,
    Popup
  }
};
</script>

<style scoped>
.add-divider {
  margin: 0 1vh;
}
</style>    